import { createFileRoute, redirect } from '@tanstack/react-router';

// The Facebook Ad Remixer was retired: its image backend was never switched on.
// Keep the published URL as a redirect so inbound links land on the tools index.
export const Route = createFileRoute('/_site/tools/facebook-ad-remixer')({
  beforeLoad: () => {
    throw redirect({ to: '/tools', statusCode: 301 });
  },
});
